module.exports = __webpack_public_path__ + "./assets/images/posx.jpg";